import { YOYDifferenceReportWrapper } from '../../components'
import AuthService from '../../utilities/services/auth.service'

export default function YOYDifferenceReportPage() {
  const organization = AuthService.getOrg()?.[0]
  return <YOYDifferenceReportWrapper organization={organization} />
}
